import { Modal, message, Row, Col, Button, Table, Select } from "antd";
import { useEffect, useState } from "react";
import DateCustom from "../../../../hook/DateCustom";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import axios from "axios";
import {
  baseUrl,
  HEADERS_EXPORT_BEN,
  POST_DETAIL_PAYMENT,
  POST_LOAN_DB2,
} from "../../../API/apiUrls";
import dayjs from "dayjs";
import { faMapLocationDot, faCarSide } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExportOutlined, FileExcelOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import LoadLawyers from "../../../../hook/LoadLawyers";
import Search from "antd/es/transfer/search";
import arabicToThai from "../../../../hook/arabicToThai";
import oneBell from "../../../../assets/images/license/oneBell.png";

const ExportCancel = ({ open, close, dataDefault }) => {
  const [convertDateThai, convertDateThaiShort] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [imageLawyer, setImageLawyer] = useState();
  const [lawyersList, setLoadingData] = LoadLawyers();
  const [lawyerId, setLawyerId] = useState(userCompany === "3" ? 10 : 3);
  const [lawyerName, setLawyerName] = useState(userCompany === "3" ? 10 : 3);
  const [lawyersOption, setLawyersOption] = useState();
  const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  useEffect(() => {
    setLoadingData(true);
    setDataQuery();
  }, []);

  useEffect(() => {
    if (lawyersList) {
      setOptionLawyer();
    }
  }, [lawyersList]);

  useEffect(() => {
    if (imageList?.length > 0) {
      renderLawyer(lawyerId);
    }
  }, [imageList]);

  const renderLawyer = async (value) => {
    console.log("value", value);
    console.log("imageList", imageList);
    const expectedName = `lawyer/user/license_lawyer/public/${value}.png`;
    const lawyerLicense = imageList?.find((item) => item.name === expectedName);

    if (!lawyerLicense) {
      console.warn("ไม่พบไฟล์ลายเซ็นสำหรับ", value);
      return;
    }

    const base64 = await toBase64(lawyerLicense.url);

    setImageLawyer(base64);
  };

  const toBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // result เป็น base64
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const setOptionLawyer = () => {
    let companySelect = null;

    console.log(userCompany);

    if (userCompany === "3") {
      companySelect = lawyersList.filter(
        (item) =>
          item.COMPANY_ID === 3 &&
          item.ROLE_ID === 3 &&
          item.ACTIVE_STATUS === 1
      );
    } else {
      companySelect = lawyersList.filter(
        (item) =>
          (item.COMPANY_ID === 1 || item.COMPANY_ID === 2) &&
          item.ROLE_ID === 3 &&
          item.ACTIVE_STATUS === 1
      );
    }
    const options = companySelect.map((item) => ({
      value: item.id,
      label: item.NNAME,
      fNmae: item.FNAME,
      lName: item.LNAME,
    }));

    // options.unshift({
    //   value: "all", // ค่าที่แทน "ทั้งหมด"
    //   label: "ทั้งหมด", // ข้อความที่แสดงใน dropdown
    // });

    let lawyerDefualt;
    if (userCompany === "3") {
      lawyerDefualt = 10;
    } else {
      lawyerDefualt = 3;
    }

    let lawyerSet = lawyersList.find((item) => item.id === lawyerDefualt);
    setLawyerName(lawyerSet);
    setLawyersOption(options);
    loadImagesList();
  };

  const setDataQuery = () => {
    console.log("setDataQuery", dataDefault);

    // ดึงเฉพาะ field "CONTNO" และแปลงเป็น string
    const formattedData = dataDefault.map((val) => `'${val.CONTNO}'`).join(",");

    // ส่งเข้า setData
    console.log({ CONTNO: formattedData });
    queryMultiData({ CONTNO: formattedData });
  };

  const queryMultiData = async (data) => {
    setLoading(true);
    console.log("queryData ImportData--->", data);

    if (!data || data.length === 0) {
      message.error("ไม่มีข้อมูลสำหรับการค้นหา");
      setLoading(false);
      return;
    }

    try {
      await axios
        .post(POST_LOAN_DB2, data, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (resQuery) => {
          if (resQuery.status === 200) {
            console.log("resQuery", resQuery.data);
            filterData(mergeDataWithGuarantors(resQuery.data));
            setLoading(false);
          } else {
            message.error("ไม่มีเลขที่สัญญาที่ค้นหา");
            console.log("ไม่มีเลขที่สัญญาที่ค้นหา");
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.status === 404) {
            message.error("ไม่มีเลขที่สัญญาที่ค้นหา");
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  const loadImagesList = async (value) => {
    console.log(value);

    await axios
      .get(baseUrl + `/files/lawyer/user/license_lawyer/public`)
      .then((response) => {
        console.log("ImageList", response.data);
        setImageList(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const mergeDataWithGuarantors = (data) => {
    console.log("mergeDataWithGuarantors", data);

    const mergedData = data.reduce((acc, record) => {
      // ข้อมูลหลักของลูกค้า (แยกตามที่อยู่)
      const mainData = (
        Array.isArray(record.CUSTOMER?.ADDRESS)
          ? record.CUSTOMER.ADDRESS
          : [record.CUSTOMER?.ADDRESS]
      ).map((addr) => ({
        ...record,
        cusType: 0, // ลูกค้าหลัก
        CONTNO: record.LOAN?.CONTNO || "", // ดึง CONTNO
        NAME: `${record.CUSTOMER.SNAM} ${record.CUSTOMER.NAME1 || ""} ${
          record.CUSTOMER.NAME2 || ""
        }`.trim(),
        ADDRESS: addr, // แยกตามที่อยู่
      }));

      const guarantorData = (record.GUARANTORS || []).map((guarantor) => {
        const addressList = Array.isArray(guarantor.ADDRESS)
          ? guarantor.ADDRESS
          : [guarantor.ADDRESS];

        // หา address ที่ตรงกับ ADDRMAIL
        const mainAddress = addressList.find(
          (addr) => addr.ADDRNO === guarantor.ADDRMAIL
        );
        return {
          ...record,
          cusType: parseInt(guarantor.GARNO), // ผู้ค้ำ
          CONTNO: record.LOAN?.CONTNO || "",
          NAME: `${guarantor.SNAM} ${guarantor.NAME1 || ""} ${
            guarantor.NAME2 || ""
          }`.trim(),
          ADDRESS: mainAddress || {}, // แสดงเฉพาะที่อยู่หลัก
        };
      });

      return [...acc, ...mainData, ...guarantorData];
    }, []);
    return mergedData.map((item, index) => ({
      ...item,
      key: index + 1,
    }));
  };

  const filterData = (value) => {
    console.log(value);
    setArrayTable(value);
  };

  const createAndDownloadExcel = async (data) => {
    // สร้าง Workbook
    const workbook = new ExcelJS.Workbook();
    let uniqueGCodes = [];
    // กำหนดประเภท GCODE ที่ต้องการแยก (ไม่ซ้ำกัน)
    if (data && data.length > 0) {
      uniqueGCodes = [...new Set(data.map((data) => data.GCODE))];
      console.log("data if1", uniqueGCodes);
    } else {
      uniqueGCodes = [...new Set(arrayTable.map((data) => data.GCODE))];
      console.log("arrayTable else1", uniqueGCodes);
    }

    // วนลูปสร้าง Sheet สำหรับแต่ละ GCODE
    uniqueGCodes.forEach((gCode) => {
      const worksheet = workbook.addWorksheet(`ประเภท`); // ใช้ GCODE เป็นชื่อ Sheet

      // กำหนดคอลัมน์ของ Worksheet
      worksheet.columns = [
        { header: "ลำดับ", key: "no", width: 10 },
        { header: "สัญญา", key: "data_type", width: 2 },
        { header: "ประเภทจ่าย", key: "forCode", width: 2 },
        { header: "วันออกจดหมาย", key: "date", width: 2 },
        { header: "ประเภทบัญชี", key: "accType", width: 2 },
        { header: "ยี่ห้อ", key: "type", width: 2 },
        { header: "ทะเบียน", key: "regNo", width: 2 },
        { header: "ค้างงวด", key: "overdue", width: 2 },
        { header: "เงินค้าง", key: "arrears", width: 2 },
        { header: "ค่าทวงถาม", key: "letter", width: 2 },
        { header: "เลขที่สัญญา", key: "contno", width: 20 },
        { header: "ชื่อลูกค้า", key: "cusName", width: 30 },
        { header: "ประเภทลูกค้า", key: "cusType", width: 10 },
        { header: "ที่อยู่", key: "addr", width: 30 },
        { header: "zipcode", key: "zipcode", width: 10 },
        { header: "ems จดหมาย", key: "emsNo", width: 25 },
        { header: "ems ใบตอบกลับ", key: "emsResponeNo", width: 25 },
      ];

      // กรองข้อมูลที่ตรงกับ GCODE
      let filteredData = [];

      if (data && data.length > 0) {
        filteredData = data.filter((data) => data.GCODE === gCode);
        console.log("data if2", filteredData);
      } else {
        filteredData = arrayTable.filter((data) => data.GCODE === gCode);
        console.log("arrayTable else2", filteredData);
      }

      // เพิ่มข้อมูลในแต่ละแถว
      filteredData.forEach((data, index) => {
        worksheet.addRow([
          index + 1,
          userCompany === "3" ? "ksm" : data.LOAN.DATA_TYPE,
          1,
          dayjs().format("YYYY-MM-DD"), // วันที่ส่ง
          "cancelHand",
          data.MORTGAGE.TYPE,
          data.MORTGAGE.REGNO,
          data.LOAN.EXP_TO - data.LOAN.EXP_FRM,
          data.LOAN.TOTPRC - data.LOAN.SMPAY,
          data.LOAN.PAYAMTAROTHR,
          data.CONTNO,
          data.NAME,
          data.cusType,
          data.ADDRESS.ADDR1,
          data.ADDRESS.ZIP,
        ]);
      });

      // จัดรูปแบบเซลล์ใน Worksheet
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดกึ่งกลางแนวตั้งและแนวนอน
        });
      });
    });

    // สร้างไฟล์และดาวน์โหลด
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // ดาวน์โหลดไฟล์
    saveAs(
      blob,
      `รายงานบอกเลิกสัญญา(มือ) ${dayjs().format("YYYY_MM_DD")}.xlsx`
    );
  };

  const createPdf = () => {
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "A4",
    });

    arrayTable?.forEach((person, index) => {
      if (index !== 0) pdf.addPage();

      let y = 20;
      pdf.setFont("THSarabunNew", "normal");
      pdf.setFontSize(16);

      // ส่วนหัว
      pdf.text(`กรุณาส่ง`, 25, y);
      y += 10;

      pdf.text(
        `${person.NAME}  (${person.CONTNO}) (${
          person.cusType === 0 ? "ผู้เช่าซื้อ" : "ผู้คำประกัน" + person.cusType
        })`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ADDR1, 40, y);

      y += 5;
      pdf.text(
        `ต.${person.ADDRESS.TUMB} อ.${person.ADDRESS.AUMPDES} จ.${person.ADDRESS.PROVDES}`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ZIP, 40, y);

      y += 48;
      pdf.setFontSize(14);
      pdf.text(`วันที่ ${convertDateThai(dayjs())}`, 150, y);
      pdf.text(`เรื่อง   บอกกล่าวให้ชำระหนี้/บอกเลิกสัญญาเช่าซื้อ`, 20, y);
      y += 5;
      pdf.text(
        `เรียน   ${person?.CUSTOMER?.SNAM}${person?.CUSTOMER?.NAME1} ${
          person?.CUSTOMER?.NAME1 ? person?.CUSTOMER?.NAME1 : ""
        } (ผู้เช่าซื้อ)`,
        20,
        y
      );

      let xLeft = 30;
      let xRight = 120;
      let yGUARANTORS = y + 5;

      person?.GUARANTORS?.forEach((g, i) => {
        let x = i % 2 === 0 ? xLeft : xRight;

        pdf.text(
          `${g.SNAM} ${g.NAME1} ${g.NAME2} (${
            g.GARNO === 0 ? "ผู้เช่าซื้อ" : "ผู้ค้ำประกัน " + g.GARNO
          })`,
          x,
          yGUARANTORS
        );

        // เมื่อครบคู่ (คนที่ 2 ในแถว) ให้ขึ้นบรรทัดใหม่
        if (i % 2 === 1) {
          yGUARANTORS += 5;
        }
      });

      // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
      y = yGUARANTORS + 15;

      pdf.text(
        `อ้างถึง   สัญญาเช่าซื้อเลขที่ ${
          person?.CONTNO
        } ฉบับลงวันที่ ${convertDateThai(person?.LOAN?.SDATE)}`,
        20,
        y
      );
      //   เนื้อหา
      const indent = "          "; // เว้นบรรทัดเริ่มต้นแบบย่อหน้า (ประมาณ 8 ช่องว่าง)
      y += 5;
      const content = [
        `${indent}ตามที่ท่านทั้ง     ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )}   คน ได้ทำหนังสือเช่าซื้อและสัญญาค้ำประกันซื้อรถยนต์     ${
          person?.MORTGAGE?.BAAB
        }    ยี่ห้อ     ${person?.MORTGAGE?.TYPE}   หมายเลขเครื่องยนต์     ${
          person?.MORTGAGE?.ENGNO
        } หมายเลขตัวถังรถยนต์     ${
          person?.MORTGAGE?.STRNO
        }   หมายเลขทะเบียน  ${
          person?.MORTGAGE?.REGNO
        } ไปจากบริษัทฯรายละเอียดปรากฎตามสัญญาเช่าซื้อ ฉบับที่อ้างอิงถึง ไปจากบริษัทฯในราคา    ${currencyFormatPoint(
          person?.LOAN?.TOTPRC
        )} บาท ตกลงผ่อนชำระ`,
        `ค่าเช่าซื้อให้แก่บริษัทฯ จำนวน     ${
          person?.LOAN?.T_NOPAY
        } งวด   งวดละ 1 เดือน ชำระเดือนละ ${currencyFormatPoint(
          person?.LOAN?.TOT_UPAY
        )} บาท ของเดือนเริ่มชำระงวดแรกภายในวันที่ ${convertDateThai(
          person?.LOAN?.FDATE
        )} และงวดสุดท้ายชำระในวันที่ ${convertDateThai(
          person?.LOAN?.FDATE
        )} โดยผู้ค้ำประกันยินยอมรับผิดหากผู้เช่าซื้อไม่ชำระหนี้ดังกล่าว`,

        `${indent}บัดนี้ปรากฏว่าผู้เช่าซื้อประพฤติผิดสัญญา ไม่ชำระค่าเช่าซื้อให้แก่บริษัทฯ เป็นจำนวน ${
          person?.LOAN?.EXP_TO - person?.LOAN?.EXP_FRM
        } งวด ติดต่อกันตั้งแต่งวดที่  ${
          person?.LOAN?.EXP_FRM
        } เป็นต้นมา เป็นค่าเช่าซื้อที่ค้างชำระถึงวันที่ออกหนังสือฉับบนี้จำนวน     ${currencyFormatPoint(
          (person?.LOAN?.EXP_TO - person?.LOAN?.EXP_FRM) *
            person?.LOAN?.TOT_UPAY
        )} บาท และคงเหลือค่าเช่าซื้อที่ค้างชำระจำนวน เงินทั้งสิ้น  ${currencyFormatPoint(
          person?.LOAN?.TOTPRC -
            person?.LOAN?.SMPAY +
            (person?.LOAN?.EXP_TO - person?.LOAN?.EXP_FRM) *
              person?.LOAN?.TOT_UPAY
        )}  บาท`,

        `${indent}ดังนั้นข้าพเจ้าในฐานะผู้รับมอบอำนาจจากบริษัทฯ จึงขอให้ท่านทั้ง ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )}  คน นำจำนวนเงินค่าเช่าซื้อที่ค้างชำระดังกล่าว
ข้างต้นพร้อมภาษีค่าเพิ่ม เบี้ยปรับค่าใช้จ่าย และเงินอื่นใดที่ต้องชำระให้ครบทันงวด ไปชำระที่บริษัทฯ ภายในกำหนด 30 วัน นับตั้งแต่วันที่ท่านได้รับหนังสือทวงถามฉบับนี้หากท่านทั้ง ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )}   คน เพิกเฉยไม่ดำเนินการภายในเวลาดังกล่าวข้างต้นแล้ว บริษัทฯ ขอถือว่าหนังสือฉบับนี่เป็นการบอกเลิกสัญญาเช่าซืิ้อ ขอให้ถือว่าหนังสือฉบับนี้เป็นการบอกเลิกสัญญาเช่าซื้อ ฉบับดังกล่าว และให้ท่าน ทั้ง ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )} คนร่วมกันหรือแทนกันส่งมอบรถยนต์ที่เช่าซื้อคืนบริษัทฯในสภาพสมบูรณ์เรียบร้อยใช้การได้ดีหากท่านไม่สามารถมอบรถยนต์ คืนบริษัทฯ ให้ใช้ราคารถยนต์แทนจำนวน      ${currencyFormatPoint(
          person?.LOAN?.TOTPRC -
            person?.LOAN?.SMPAY +
            (person?.LOAN?.EXP_TO - person?.LOAN?.EXP_FRM) *
              person?.LOAN?.TOT_UPAY
        )}    บาท       ${numberToThaiText(
          person?.LOAN?.TOTPRC -
            person?.LOAN?.SMPAY +
            (person?.LOAN?.EXP_TO - person?.LOAN?.EXP_FRM) *
              person?.LOAN?.TOT_UPAY
        )} ${
          person?.LOAN?.PAYAMTAROTHR
            ? "ค่าติดตามทวงถามเป็นเงิน " +
              currencyFormatPoint(person?.LOAN?.PAYAMTAROTHR) +
              " บาท"
            : ""
        }`,

        `${indent}นับแต่วันที่ผิดนัดดอกเบี้ยในอัตราร้อยละ 15 ต่อปีไปชำระให้แก่บริษัทฯ ณ ที่ทำการบริษัทฯตามที่อยู่ข้างบนหนังสือฉบับนี้ใน เวลาทำการปกติ หากท่านเพิกเฉยโดยมิดำเนินการดังกล่าวภายในเวลาที่กำหนดข้าพเจ้ามีความเสียใจที่จะต้องดำเนินการกับท่านตาม กฎหมายต่อไป`,
      ];

      content.forEach((line) => {
        const splitText = pdf.splitTextToSize(line, 170);
        pdf.text(splitText, 20, y);
        y += splitText.length * 6;
      });

      pdf.text(`ขอแสดงความนับถือ`, 45, y + 5); // (x, y)
      let imageWidthImg = 25; // Adjust width to fit your needs
      let imageHeightImg = 15; // Adjust height to fit your needs
      pdf.addImage(
        imageLawyer,
        "PNG",
        45,
        y + 7,
        imageWidthImg,
        imageHeightImg
      );

      pdf.text(
        `(${lawyerName ? lawyerName?.FNAME : "                        "}  ${
          lawyerName ? lawyerName?.LNAME : "                         "
        })`,
        lawyerId === 3 ? 40 : 45,
        y + 28
      ); // (x, y)
      pdf.text("ทนายความประจำบริษัทฯ", 45, y + 33); // (x, y)
      pdf.text("ผู้รับมอบอำนาจ", 50, y + 38); // (x, y)
      pdf.text(`ขอแสดงความนับถือ`, 145, y + 5); // (x, y)
      pdf.addImage(oneBell, "PNG", 145, y + 7, imageWidthImg, imageHeightImg);

      pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 28); // (x, y)
      pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 33); // (x, y)
      pdf.text("ผู้ออกจดหมาย", 150, y + 38); // (x, y)
    });

    // เพิ่มหน้าใหม่
    pdf.addPage();

    // ตั้งค่าฟอนต์
    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(16);

    // config layout
    let finalYLeft = 20;
    let finalYRight = 20;
    let leftX = 10;
    let rightX = 115; // จุดเริ่มคอลัมน์ขวา
    let rowHeight = 30; // ความสูงต่อคน
    let count = 0;

    arrayTable.forEach((person, index) => {
      const x = count % 2 === 0 ? leftX : rightX;
      let y = count % 2 === 0 ? finalYLeft : finalYRight;

      // --- ชื่อ + ประเภท ---
      const nameType = `${person.NAME} (${
        person.cusType === 0 ? "ผู้เช่าซื้อ" : "คนค้ำประกัน" + person.cusType
      }) (${person.CONTNO})`;
      pdf.text(nameType, x, y);
      y += 6;

      // --- ที่อยู่ บรรทัด 1 ---
      if (person.ADDRESS?.ADDR1) {
        pdf.text(`เลขที่ ${person.ADDRESS.ADDR1}`, x, y);
        y += 6;
      }

      // --- ที่อยู่ บรรทัด 2 ---
      const addrLine2 = `ต.${person.ADDRESS.TUMB} อ.${person.ADDRESS.AUMPDES} จ.${person.ADDRESS.PROVDES}`;
      pdf.text(addrLine2, x, y);
      y += 6;

      // --- ZIP ---
      pdf.text(person.ADDRESS.ZIP || "", x, y);

      // --- อัปเดต Y ตามคอลัมน์ ---
      if (count % 2 === 0) {
        finalYLeft += rowHeight;
      } else {
        finalYRight += rowHeight;
      }

      count++;

      // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
      if (finalYLeft > 20 + rowHeight * 9) {
        pdf.addPage();
        pdf.setFont("THSarabunNew", "normal");
        pdf.setFontSize(16);
        finalYLeft = 20;
        finalYRight = 20;
      }
    });

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  const onChangeSelectLawyer = (value, label) => {
    console.log("onChangeSelectLawyer-->", value, label);
    let lawyerSet = lawyersList.find((item) => item.NNAME === label.label);
    setLawyerName(lawyerSet);

    setLawyerId(value);
    renderLawyer(value);
  };

  const search = (event) => {
    console.log("query--->", event.target.value);
    onSearch(event.target.value);
  };

  const onSearch = (value) => {
    let result = arrayTable.filter((item) => item.CONTNO.includes(value));
    setArrayTable(result);
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (record.CONTNO ? record.CONTNO : null),
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER_TNAM",
      key: "CUSTOMER_TNAM",
      align: "center",
      render: (text, record) => <>{record.NAME ? record.NAME : null} </>,
    },
    {
      title: "ประเภทลูกค้า",
      dataIndex: "CUSTOMER_TYPE",
      key: "CUSTOMER_TYPE",
      align: "center",
      render: (text, record) => (
        <>
          {record.cusType === 0 ? "ผู้เช่าซื้อ" : `คนค้ำที่ ${record.cusType}`}{" "}
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        <span style={{ fontSize: 22, fontWeight: 700, color: "#333" }}>
          ออกรายงาน
        </span>
      }
      open={open}
      onCancel={handleCancel}
      width={850}
      footer={null}
      centered
      styles={{
        body: { padding: "24px 32px" }, // ใช้แทน bodyStyle
      }}
    >
      <Row gutter={[16, 24]} align="middle" style={{ marginBottom: 16 }}>
        {/* ปุ่มออกจดหมาย */}
        <Col span={12} style={{ textAlign: "left" }}>
          <Button
            type="primary"
            icon={<ExportOutlined />}
            size="large"
            style={{
              padding: "0 24px",
              borderRadius: 8,
              fontWeight: 600,
            }}
            onClick={createPdf}
          >
            ออกจดหมายบอกเลิก
          </Button>
        </Col>

        {/* ปุ่มออก Excel */}
        <Col span={12} style={{ textAlign: "right" }}>
          <Button
            icon={<FileExcelOutlined />}
            size="large"
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              padding: "0 24px",
              borderRadius: 8,
              fontWeight: 600,
            }}
            onClick={createAndDownloadExcel}
          >
            ออก Excel
          </Button>
        </Col>
      </Row>

      <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 16 }}>
        {/* เลือกทนาย */}
        <Col span={18} style={{ textAlign: "left" }}>
          <Select
            placeholder="เลือกทนาย"
            showSearch
            optionFilterProp="label"
            defaultValue={userCompany === "3" ? 10 : 3}
            onChange={(value, label) => onChangeSelectLawyer(value, label)}
            options={lawyersOption}
            size="large"
            style={{
              width: "100%",
              maxWidth: 175,
              borderRadius: 6,
            }}
          />
        </Col>

        {/* ค้นหาสัญญา */}
        <Col span={6} style={{ textAlign: "end" }}>
          <Search
            placeholder="ค้นหาสัญญา"
            onChange={search}
            enterButton
            size="small" // ← ขนาดเล็กสุด
            style={{
              width: "100%",
              maxWidth: 100, // ปรับขนาดตามต้องการ
              borderRadius: 6,
            }}
          />
        </Col>
      </Row>

      {/* ตารางข้อมูล */}
      <Row>
        <Col span={24}>
          <Table
            size="middle"
            columns={columns}
            dataSource={arrayTable}
            pagination={{ pageSize: 10 }}
            bordered
            style={{ marginTop: 16 }}
            footer={() => (
              <div
                style={{ textAlign: "right", fontWeight: 600, fontSize: 16 }}
              >
                จำนวนทั้งหมด {arrayTable.length}
              </div>
            )}
          />
        </Col>
      </Row>
    </Modal>
  );
};
export default ExportCancel;
